"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
const monitoringSchema = Yup.object()
  .shape({
    StartTime: Yup.string()
      .matches(
        /^(([-]?(\d)*(s|m|h|d|mo|y))|(start)|(now)|(1[0-2]|0[1-9])-(3[01]|[12][0-9]|0[1-9])-[0-9]{4} (2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9]))$/,
        {
          message:
            "Incorrect format. e.g -5d for last 5 days. 5d for next 5 days (s: second, m: minutes, h: hour, mo: months, y: year, start: from starting)",
          excludeEmptyString: true
        }
      )
      .required("Please enter start time"),
    EndTime: Yup.string()
      .matches(
        /^(([-]?(\d)*(s|m|h|d|mo|y))|(start)|(now)|(1[0-2]|0[1-9])-(3[01]|[12][0-9]|0[1-9])-[0-9]{4} (2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9]))$/,
        {
          message:
            "Incorrect format. e.g -5d for last 5 days. 5d for next 5 days (s: second, m: minutes, h: hour, mo: months, y: year, now: current time)",
          excludeEmptyString: true
        }
      )
      .required("Please enter end time"),
    Queries: Yup.array()
      .of(Yup.object().required())
      .required()
  })
  .required();
class MonitoringNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    let selectedResource = node.getSelectedResource();
    if (!data) return false;
    return helper_1.isValid(
      [
        { schema: monitoringSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() },
        { schema: IValidation_1.selectedResourceSchema, data: selectedResource }
      ],
      node.getNodeId()
    );
  }
}
exports.MonitoringNodeValidation = MonitoringNodeValidation;
//# sourceMappingURL=MonitoringNodeValidation.js.map
